import { Button } from "@/components/button";
import {
  usePlaybackMediator,
  useTimelinePlayback,
  useVideoPlayback,
} from "@/contexts/playback-context";
import IconPlayerTrackNextFilled from "~icons/tabler/player-track-next-filled";
import { TIME_MARKER_ID } from "../timeline";
import toast from "react-hot-toast";
import { Tooltip } from "@radix-ui/themes";

export function SkipToVideoStart() {
  const videoPlayback = useVideoPlayback();
  const timelinePlayback = useTimelinePlayback();
  const mediator = usePlaybackMediator();

  const onClick = () => {
    const videoStartTime = videoPlayback.videoContext.startTime.peek();
    const currentTime = timelinePlayback.currentTime.peek();

    if (videoStartTime.getTime() - currentTime > 0) {
      mediator.seek(videoStartTime, TIME_MARKER_ID);
    } else {
      toast("Video has already started");
    }
  };

  return (
    <Tooltip content="Jump to video start">
      <Button onClick={onClick}>
        <IconPlayerTrackNextFilled />
      </Button>
    </Tooltip>
  );
}
